import { Helmet } from '@dr.pogodin/react-helmet';
import type React from 'react';
import { Route, Routes, useLocation } from 'react-router';
import type { BrainAtlasType, MultiLang } from '../config';
import SiteIndex from '../custom/SiteIndex';
import Functions from '../functions';
import Footer from './Footer';
import Header from './Header';
import PageNotFound from './lib/PageNotFound';
import MainContent from './MainContent';

interface Props {
    lang: MultiLang;
}

interface PropsMain extends Props {
    type: BrainAtlasType;
    isHtml: boolean;
    isLink: boolean;
}

const PageMain: React.FC<PropsMain> = (props) => {
    const { lang, type, isHtml, isLink } = props;
    return (
        <>
            <Header lang={lang} type={type} />
            <div id="main">
                <MainContent lang={lang} type={type} isHtml={isHtml} isLink={isLink} />
            </div>
            <Footer lang={lang} type={type} isLink={isLink} />
        </>
    );
};

const AppRoot: React.FC<Props> = (props) => {
    const { lang } = props;
    const location = useLocation();
    const match = location.pathname.match(/^\/(degu|jm|marmoset)(?:\/|$|(?:_(html)(?:\/$|$|\/(link\.html$))))/);
    const isHtml = match !== null ? typeof match[2] !== 'undefined' : false;
    const isLink = match !== null ? typeof match[3] !== 'undefined' : false;

    return (
        <div id="page">
            <Helmet>
                <title>
                    {Functions.siteTitle(lang)} - {Functions.siteSlogan(lang)}
                </title>
            </Helmet>
            <Routes>
                <Route index element={<SiteIndex lang={lang} />} />
                <Route
                    path="degu_html/*"
                    element={<PageMain lang={lang} type="degu" isHtml={isHtml} isLink={isLink} />}
                />
                <Route path="jm_html/*" element={<PageMain lang={lang} type="jm" isHtml={isHtml} isLink={isLink} />} />
                <Route
                    path="marmoset_html/*"
                    element={<PageMain lang={lang} type="marmoset" isHtml={isHtml} isLink={isLink} />}
                />
                <Route path="degu/*" element={<PageMain lang={lang} type="degu" isHtml={isHtml} isLink={isLink} />} />
                <Route path="jm/*" element={<PageMain lang={lang} type="jm" isHtml={isHtml} isLink={isLink} />} />
                <Route
                    path="marmoset/*"
                    element={<PageMain lang={lang} type="marmoset" isHtml={isHtml} isLink={isLink} />}
                />
                <Route path="*" element={<PageNotFound lang={lang} />} />
            </Routes>
        </div>
    );
};

export default AppRoot;
